var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfile/MemberProfileInfo.jinja"] = require( "front/components/MemberProfile/MemberProfileInfo.jinja" );
dependencies["front/components/MemberProfile/MemberProfileSettings.jinja"] = require( "front/components/MemberProfile/MemberProfileSettings.jinja" );
dependencies["front/components/MemberProfile/MemberProfileBio.jinja"] = require( "front/components/MemberProfile/MemberProfileBio.jinja" );
dependencies["front/components/MemberProfile/MemberProfileDomicile.jinja"] = require( "front/components/MemberProfile/MemberProfileDomicile.jinja" );
dependencies["front/components/MemberProfile/MemberProfileSkills.jinja"] = require( "front/components/MemberProfile/MemberProfileSkills.jinja" );
dependencies["front/components/MemberProfile/MemberProfileExperience.jinja"] = require( "front/components/MemberProfile/MemberProfileExperience.jinja" );
dependencies["front/components/MemberProfile/MemberProfileRecognition.jinja"] = require( "front/components/MemberProfile/MemberProfileRecognition.jinja" );
dependencies["front/components/MemberProfile/MemberProfileLocation.jinja"] = require( "front/components/MemberProfile/MemberProfileLocation.jinja" );
dependencies["front/components/MemberProfile/MemberProfileCredits.jinja"] = require( "front/components/MemberProfile/MemberProfileCredits.jinja" );
dependencies["front/components/MemberProfile/MemberProfilePortfolio.jinja"] = require( "front/components/MemberProfile/MemberProfilePortfolio.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfile.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfile/MemberProfileInfo.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileInfo")) {
var t_7 = t_4.MemberProfileInfo;
} else {
cb(new Error("cannot import 'MemberProfileInfo'")); return;
}
context.setVariable("MemberProfileInfo", t_7);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileSettings.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "MemberProfileSettings")) {
var t_11 = t_8.MemberProfileSettings;
} else {
cb(new Error("cannot import 'MemberProfileSettings'")); return;
}
context.setVariable("MemberProfileSettings", t_11);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileBio.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "MemberProfileBio")) {
var t_15 = t_12.MemberProfileBio;
} else {
cb(new Error("cannot import 'MemberProfileBio'")); return;
}
context.setVariable("MemberProfileBio", t_15);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileDomicile.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "MemberProfileDomicile")) {
var t_19 = t_16.MemberProfileDomicile;
} else {
cb(new Error("cannot import 'MemberProfileDomicile'")); return;
}
context.setVariable("MemberProfileDomicile", t_19);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileSkills.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
t_20.getExported(function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
if(Object.prototype.hasOwnProperty.call(t_20, "MemberProfileSkills")) {
var t_23 = t_20.MemberProfileSkills;
} else {
cb(new Error("cannot import 'MemberProfileSkills'")); return;
}
context.setVariable("MemberProfileSkills", t_23);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileExperience.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
t_24.getExported(function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
if(Object.prototype.hasOwnProperty.call(t_24, "MemberProfileExperience")) {
var t_27 = t_24.MemberProfileExperience;
} else {
cb(new Error("cannot import 'MemberProfileExperience'")); return;
}
context.setVariable("MemberProfileExperience", t_27);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileRecognition.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
t_28.getExported(function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
if(Object.prototype.hasOwnProperty.call(t_28, "MemberProfileRecognition")) {
var t_31 = t_28.MemberProfileRecognition;
} else {
cb(new Error("cannot import 'MemberProfileRecognition'")); return;
}
context.setVariable("MemberProfileRecognition", t_31);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileLocation.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
t_32.getExported(function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
if(Object.prototype.hasOwnProperty.call(t_32, "MemberProfileLocation")) {
var t_35 = t_32.MemberProfileLocation;
} else {
cb(new Error("cannot import 'MemberProfileLocation'")); return;
}
context.setVariable("MemberProfileLocation", t_35);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfileCredits.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_37,t_36) {
if(t_37) { cb(t_37); return; }
t_36.getExported(function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
if(Object.prototype.hasOwnProperty.call(t_36, "MemberProfileCredits")) {
var t_39 = t_36.MemberProfileCredits;
} else {
cb(new Error("cannot import 'MemberProfileCredits'")); return;
}
context.setVariable("MemberProfileCredits", t_39);
output += "\n";
env.getTemplate("front/components/MemberProfile/MemberProfilePortfolio.jinja", false, "assets/app/front/components/MemberProfile/MemberProfile.jinja", false, function(t_41,t_40) {
if(t_41) { cb(t_41); return; }
t_40.getExported(function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
if(Object.prototype.hasOwnProperty.call(t_40, "MemberProfilePortfolio")) {
var t_43 = t_40.MemberProfilePortfolio;
} else {
cb(new Error("cannot import 'MemberProfilePortfolio'")); return;
}
context.setVariable("MemberProfilePortfolio", t_43);
output += "\n\n";
var macro_t_44 = runtime.makeMacro(
[], 
["data", "isOwner"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isOwner", Object.prototype.hasOwnProperty.call(kwargs, "isOwner") ? kwargs["isOwner"] : false);var t_45 = "";t_45 += "\n    <div class=\"MemberProfile\">\n        ";
t_45 += runtime.suppressValue((lineno = 15, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileInfo"), "MemberProfileInfo", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_45 += "\n            ";
t_45 += runtime.suppressValue((lineno = 17, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileSettings"), "MemberProfileSettings", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_45 += "\n        ";
;
}
t_45 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"bio")) {
t_45 += "\n            ";
t_45 += runtime.suppressValue((lineno = 21, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileBio"), "MemberProfileBio", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n        ";
;
}
t_45 += "\n        <div class=\"MemberProfile-blocks\">";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") != 0)) {
t_45 += "\n                ";
t_45 += runtime.suppressValue((lineno = 25, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileDomicile"), "MemberProfileDomicile", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n            ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"skillsDisplay") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"skillsDisplay")))) {
t_45 += "\n                ";
t_45 += runtime.suppressValue((lineno = 28, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileSkills"), "MemberProfileSkills", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n            ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences")))) {
t_45 += "\n                ";
t_45 += runtime.suppressValue((lineno = 31, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileExperience"), "MemberProfileExperience", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n            ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recognitions") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recognitions")))) {
t_45 += "\n                ";
t_45 += runtime.suppressValue((lineno = 34, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileRecognition"), "MemberProfileRecognition", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n            ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locationsDisplay") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locationsDisplay")))) {
t_45 += "\n                ";
t_45 += runtime.suppressValue((lineno = 37, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileLocation"), "MemberProfileLocation", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n            ";
;
}
t_45 += "</div>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits")))) {
t_45 += "\n            ";
t_45 += runtime.suppressValue((lineno = 41, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileCredits"), "MemberProfileCredits", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n        ";
;
}
t_45 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")))) {
t_45 += "\n            ";
t_45 += runtime.suppressValue((lineno = 44, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfilePortfolio"), "MemberProfilePortfolio", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_45 += "\n        ";
;
}
t_45 += "\n\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_45 += "\n            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"bio") && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") != 0) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"skillsDisplay") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"skillsDisplay"))) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"experiences"))) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recognitions") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"recognitions"))) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locationsDisplay") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"locationsDisplay"))) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits"))) && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")))) {
t_45 += "\n                <div class=\"MemberProfile-empty\">\n                    <div class=\"MemberProfile-emptyCaption\">";
t_45 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"firstName"), env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"lastName"), env.opts.autoescape);
t_45 += " hasn’t filled out their profile yet.</div>\n                    <div class=\"MemberProfile-emptyMessage\">you can explore all our <a href=\"";
t_45 += runtime.suppressValue((lineno = 51, colno = 97, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:members"])), env.opts.autoescape);
t_45 += "\">ADG members</a></div>\n                </div>\n            ";
;
}
t_45 += "\n        ";
;
}
t_45 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_45);
});
context.addExport("MemberProfile");
context.setVariable("MemberProfile", macro_t_44);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfile.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfile.jinja
// module id = 99
// module chunks = 0